module.exports = __webpack_public_path__ + "static/img/Siteni-Taukamo.575e951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Siteni-Taukamo.jpg
// module id = yqNO
// module chunks = 0